(function () {
  var DESKTOP_MQ = '(min-width: 990px)';

  function handleCtaClick(event) {
    var button = event.currentTarget;
    if (button.disabled) return;

    var productSection = document.querySelector('.juno-product');
    if (!productSection) return;

    var subInput = productSection.querySelector('[data-juno-plan-input][value="sub"]');
    var sellingPlanField = productSection.querySelector('[data-juno-selling-plan]');
    if (subInput) {
      subInput.checked = true;
      if (sellingPlanField) {
        sellingPlanField.value = subInput.dataset.planId || '';
      }
      subInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var submitButton = productSection.querySelector('form[data-type="add-to-cart-form"] [type="submit"]');
    if (submitButton) {
      submitButton.click();
    }
  }

  function getRevealOffset() {
    var value = getComputedStyle(document.documentElement)
      .getPropertyValue('--juno-header-content-offset')
      .trim();
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 74;
  }

  function initScrollReveal(section) {
    if (section.dataset.productsFirstRevealBound === 'true') return;
    section.dataset.productsFirstRevealBound = 'true';

    var mq = window.matchMedia(DESKTOP_MQ);
    var productCta = document.querySelector('[data-juno-cta]');
    var ticking = false;
    var isVisible = false;
    // Hysteresis so the bar doesn't flicker around the threshold
    var SHOW_BUFFER = 8;
    var HIDE_BUFFER = 48;

    function setVisible(visible) {
      if (isVisible === visible) return;
      isVisible = visible;
      section.classList.toggle('is-visible', visible);
      section.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function updateVisibility() {
      ticking = false;

      if (!mq.matches || !productCta) {
        setVisible(false);
        return;
      }

      var offset = getRevealOffset();
      var ctaBottom = productCta.getBoundingClientRect().bottom;

      if (!isVisible && ctaBottom < offset - SHOW_BUFFER) {
        setVisible(true);
      } else if (isVisible && ctaBottom > offset + HIDE_BUFFER) {
        setVisible(false);
      }
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateVisibility);
      }
    }

    mq.addEventListener('change', requestUpdate);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
  }

  function initSection(section) {
    var cta = section.querySelector('[data-products-first-cta]');
    if (cta && cta.dataset.productsFirstBound !== 'true') {
      cta.dataset.productsFirstBound = 'true';
      cta.addEventListener('click', handleCtaClick);
    }

    initScrollReveal(section);
  }

  function initAll() {
    document.querySelectorAll('.products-first').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.products-first');
    if (section) {
      section.dataset.productsFirstRevealBound = 'false';
      initSection(section);
    }
  });
})();
